<mapfre-auditlib-input [form]="formFilter" label="{{ 'SEARCH.GLOBAL.LABEL' | translate}}"
    placeholder="{{ placeholder || 'SEARCH.PLACEHOLDER' | translate}}" buttonIcon="icon-16-px-mas"
    (buttonClicked)="onAddFilterClicked()" [skipHighlighter]="true"></mapfre-auditlib-input>
<div class="d-flex mt-4" *ngIf="filters?.length">
    <div class="chip chip-icon-r mr-6 cursor-pointer" *ngFor="let filter of filters;let i = index"
        (click)="onRemoveFilterClick(i)">
        {{filter}} <i class="icon icon-16-px-cancelar color-white"></i>
    </div>
    <div class="chip chip-outlined cursor-pointer" (click)="onClearFiltersClick()">
        {{ 'FILTER.CLEAR' | translate}}
    </div>
</div>